import { useQuery } from "@tanstack/react-query";

import { ArticlesRedactionPanel } from "@/components/ui/admin/articles/ArticlesRedactionPanel";
import { SectionSubPage } from "@/components/ui/admin/SectionSubPage";
import { createArticleService } from "@/core/services/factory";
import { useAuth } from "@/lib/auth";
import { useTranslations } from "@/lib/useTranslations";

export function ArticlesRedactionPage() {
  const t = useTranslations("articles.redaction");
  const { profile, isLoading: isAuthLoading } = useAuth();
  const assigneeId = profile?.id ?? "";

  const { data: items = [], isFetching } = useQuery({
    queryKey: ["articles-redaction-assigned", assigneeId],
    enabled: Boolean(assigneeId),
    queryFn: async () => {
      const articles = createArticleService();
      return articles.listAssignedInReview(assigneeId);
    },
  });

  if (isAuthLoading || (assigneeId && isFetching && items.length === 0)) {
    return (
      <div className="mx-auto flex w-full max-w-6xl flex-1 items-center justify-center px-6 py-10 text-sm text-neutral-500">
        {t("loading")}
      </div>
    );
  }

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-1 flex-col gap-6 overflow-y-auto px-6 py-10">
      <header className="space-y-1">
        <p className="text-sm font-medium uppercase tracking-widest text-neutral-500">
          {t("eyebrow")}
        </p>
        <h1 className="text-3xl font-semibold tracking-tight text-whart-text">
          {t("title")}
        </h1>
        <p className="text-sm text-neutral-600">{t("description")}</p>
      </header>

      <ArticlesRedactionPanel items={items} isRefreshing={isFetching} />
    </div>
  );
}

export function ArticlesStatisticsPage() {
  const t = useTranslations("articles.statistics");
  return (
    <SectionSubPage
      eyebrow={t("eyebrow")}
      title={t("title")}
      description={t("description")}
    />
  );
}
